import {
    createSelector,
} from 'reselect';

import { createAppSelector } from 'wanderu-ducks-utils';

import SLICE_NAMESPACE from '../../types';
import NAMESPACE from './types';

function _getPriceData(appState) {
    return appState[SLICE_NAMESPACE][NAMESPACE];
}

const selectMinimumDailyPrices = createSelector(
    _getPriceData,
    (priceData) => priceData
        ? priceData.minimumDailyPrices
        : undefined,
);

const selectMinimumDailyPricesFromPlace = createAppSelector(
    (appState, placeId) => placeId,
    selectMinimumDailyPrices,
    (placeId, priceData) => (priceData && placeId)
        ? priceData[placeId]
        : undefined,
);

const selectMinimumDailyPricesFromPlaceToPlace = createAppSelector(
    (appState, fromPlace, toPlace) => toPlace,
    selectMinimumDailyPricesFromPlace,
    (placeId, priceData) => (priceData && placeId)
        ? priceData[placeId]
        : undefined,
);

const _mapDailyMinimumPrice = (direction) => (data) => data
    ? data[direction === 'return'
        ? 'returnMinPricing'
        : 'departMinPricing'].price
    : undefined;

const selectDailyDepartMinimumPricing = createSelector(
    selectMinimumDailyPricesFromPlaceToPlace,
    _mapDailyMinimumPrice('depart'),
);

const selectDailyReturnMinimumPricing = createSelector(
    selectMinimumDailyPricesFromPlaceToPlace,
    _mapDailyMinimumPrice('return'),
);

export {
    selectDailyDepartMinimumPricing,
    selectDailyReturnMinimumPricing,
    selectMinimumDailyPrices,
    selectMinimumDailyPricesFromPlace,
    selectMinimumDailyPricesFromPlaceToPlace,
};
